import { render, staticRenderFns } from "./MySharesPage.vue?vue&type=template&id=44638564"
import script from "./MySharesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MySharesPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports